module.exports = __webpack_public_path__ + "img/myapp_bg.542ccca1.png";